import { Box, BoxProps, Text } from "@chakra-ui/react";

type Option = {
  text: string;
  value: number | string;
};

type BaseSelectProps = BoxProps & {
  label: string;
  options?: Option[];
};
const BaseSelect: React.FC<BaseSelectProps> = ({
  label,
  options = [],
  ...props
}) => {
  return (
    <Box
      {...props}
      py={2}
      px={4}
      height={9}
      display={"flex"}
      borderRadius={"md"}
      alignItems={"center"}
      border="1px solid #E5E7EB"
      justifyContent={{ base: "space-between", lg: "flex-start" }}
    >
      <Text
        mr={2}
        fontSize={"sm"}
        fontFamily={"Inter"}
        fontWeight={"medium"}
        color={"#374151"}
      >
        {label}
      </Text>
      <select
        id="select-format"
        style={{ fontSize: "14px", fontWeight: 500, color: "#374151" }}
      >
        {options.map((opt, i) => (
          <option key={i} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>
    </Box>
  );
};

export { BaseSelect };
